import { checkCanUseWebP } from './checkCanUseWebP';

const canUseWebP = checkCanUseWebP();

export const getSmallThumbnailURL = (thumbnailURL, type, forcedExt) => {
  if (thumbnailURL && thumbnailURL.endsWith('/')) {
    let ext;
    if (forcedExt) {
      ext = forcedExt;
    } else {
      ext = 'webp';
      if (!canUseWebP) {
        if (type === 'element' || type === 'designer-elements') {
          ext = 'png';
        } else {
          ext = 'jpeg';
        }
      }
    }

    // let ext = 'jpeg';
    const parts = thumbnailURL.split('/');
    thumbnailURL = thumbnailURL + `${parts[parts.length - 2]}-400.${ext}`;
  }
  return thumbnailURL;
};
